import React from "react"
import { Spinner } from "react-bootstrap"
import deleteddataApp from "../Shared/Controller/deleteddataApp"
import { RestoreImg, DeleteImg } from "../common/ImageConstants";
import { Link } from "react-router-dom";
import * as Constants from "../partials/CommonConstant";
import ConfirmModal from "../common/ConfirmModal";
import NotFound from "../common/NotFound";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { GetRole } from "../common/CommonController";

class DeletedUsers extends deleteddataApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      userList: [],
      showDeleteModal: false,
      showRestoreModal: false,
      userId: "",
      page: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: "username",
      sortOrder: "asc",      
      searchText: "",
      status: 0
    }
  }
  componentDidMount = () => {
    this.getUsers();
  }


  handlePageChange = (page) => {
    this.setState({ page }, this.getUsers);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ perPage: newPerPage, page }, this.getUsers);
  };

  // handleSort = (column, sortDirection) => {
  //   this.setState(
  //     {
  //       sortBy: column.sortField,
  //       sortOrder: sortDirection,
  //     },
  //     this.getUsers
  //   );
  // };

  handleSort = (column, sortDirection) => {
    const newSortBy = column.sortField || column.selector;
    
    this.setState((prevState) => ({
      sortBy: newSortBy,
      sortOrder: prevState.sortBy === newSortBy && prevState.sortOrder === "asc" ? "desc" : "asc",
      page: 1, // reset to first page
    }), this.getUsers);
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearchSubmit = () => {
    this.setState({ page: 1 }, this.getUsers);
  };

  clearSearch = () => {
    this.setState({ searchText: "", page: 1 }, this.getUsers);
  };

  getColumnData = (data) => {
    let columnData = "";
    if (data.type === "action") {
      return (
        <div className="edit-icon text-center">
          <Link to="/" className="ms-2" onClick={(e) => this.onClickUserRestore(e, data.item.id)}>
            <img src={RestoreImg} alt="Restore" title="Restore" />
          </Link>
          <Link to="/" className="ms-2" onClick={(e) => this.onClickPermenantDeleteUser(e, data.item.id)}>
            <img src={DeleteImg} alt="Permanent Delete" title="Permanent Delete" />
          </Link>
        </div>
      );
    }
    return columnData;
  }

  render() {

    const {
      userList,
      loading,
      page,
      perPage,
      totalRows,
      searchText,
    } = this.state;

    // Create table headers
    const data = this.state.userList;
    const columns = [
      {
        name: "Username",
        selector: row => row.username,
        sortable: true,
        sortField: "username"
      },
      {
        name: "Name",
        selector: row => row.fullname,
        sortable: true,
        cell: d => { return d.fullname },
        sortField: "firstname"
      },
      {
        name: "Email",
        selector: row => row.email,
        sortable: true,
        sortField: "email"
      },
      {
        name: "Role",
        selector: row => row.role,
        sortable: true,
        cell: d => { return GetRole(d.role) },
        sortField: "role"
      },
      {
        name: "Action",
        center: true,
        cell: d => { return this.getColumnData({ type: "action", item: d }) }
      }
    ];

    const tableData = {
      columns,
      data
    };
    return (
      <>
        <div className="dashboard-card-wrapper deleted-page-data">
        <ConfirmModal show={this.state.showDeleteModal} type="permanentDelete" customMessage={<><strong>If you delete this user, All data created by this user will also be permanently deleted which includes projects, investors, platforms, files, templates, questions, logs, task reviews etc.</strong>
            <br /><br />
            Are you sure you want permanently delete this user?</>}
            onCloseModal={() => this.onDeleteCloseModal()}
            confirmClick={(e) => this.handlePermanentDelete(e, 'User')} />
          <ConfirmModal show={this.state.showRestoreModal} type="restore"
            onCloseModal={() => this.onRestoreCloseModal()}
            module="user"
            confirmClick={(e) => this.handleRestore(e, 'User')} />
          <div className="row align-items-center">
            <div className="col-12 text-end">
              <Link to={Constants.users} className="btn btn-blue btn-nex">Active Users</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll data-table">

                {/* Custom Search Input */}
                <div className="data-table-extensions d-flex align-items-center">

                    <div className="data-table-extensions-filter position-relative">

                      <label htmlFor="filterDataTable" className="icon"></label>                        
                      <input
                        type="text"
                        name= "filterDataTable"
                        className="filter-text w-100"
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => this.setState({ searchText: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.setState({ page: 1 }, this.getUsers);
                          }
                        }}                       
                      />
                      
                      {searchText && (
                        <span
                          className="clear-icon"
                          onClick={() => {
                            this.setState({ searchText: "", page: 1 }, this.getUsers);
                          }}
                          style={{
                            position: "absolute",
                            right: "13px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "23px",
                            color: "#545454"
                          }}
                          title="Clear search"
                        >
                        ×
                        </span>
                      )}

                    </div>
                    
                    <button
                      className="ms-2"
                      title="Click to Search"
                      disabled={searchText.trim() === ""}
                      style={{
                        backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608", // lighter when disabled
                        color: "white",
                        border: "none",
                        padding: "8px 12px",
                        borderRadius: "50px",
                        cursor: searchText.trim() === "" ? "default" : "pointer"
                      }}
                      onClick={() => {
                        this.setState({ page: 1 }, this.getUsers);
                      }}
                    >
                      Search
                    </button>

                </div>
                
                {this.state.userList && this.state.userList.length !== 0 && this.state.loading === false &&
                  
                  <DataTable
                    columns={columns}
                    data={userList}
                    //defaultSortField="username"                    
                    pagination
                    progressPending={loading}
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    sortServer
                    onSort={this.handleSort}
                    highlightOnHover
                    pointerOnHover
                  />   

                }
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={10} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }

                {/* Not found */}
                {this.state.loading === false && this.state.userList && this.state.userList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default DeletedUsers